<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    backgroundColor?: 'pink' | 'black';
    height?: 'short' | 'tall';
    backgroundImageUrl?: string;
    id?: string;
  }>(),
  {
    backgroundColor: 'black',
    height: 'short',
  },
);

const backgroundImage = computed(() => (props.backgroundImageUrl ? `url(${props.backgroundImageUrl})` : 'none'));
</script>
<template>
  <div :id="id" :class="`info-card-container ${backgroundColor} ${height}`">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
.info-card-container {
  width: 100%;
  aspect-ratio: 1 / 1;
  padding: 24px;
  border-radius: 4px;
  max-height: 345px;
  background-color: var(--secondary-bg-color);

  text-align: left;
  color: var(--secondary-text-color);

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 12px;

  // For the pseudo-element
  position: relative;
  overflow: hidden;
  z-index: 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    // Background image
    background-image: v-bind('backgroundImage');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    transition: transform 0.5s;
    z-index: -1;
  }

  &:hover::before {
    transform: scale(1.05);
  }

  &.pink {
    background-color: var(--pale-pinkish-color);
    color: var(--primary-text-color);
  }

  &.tall {
    aspect-ratio: 2 / 3;
    max-height: 690px;
  }
}
</style>
